(function () {
  function cartRoute(path) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  async function addSubscription(variantId, qty, sellingPlanId) {
    const item = {
      id: variantId,
      quantity: parseInt(qty, 10) || 1
    };

    if (sellingPlanId) item.selling_plan = sellingPlanId;

    const res = await fetch(cartRoute('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error('Add subscription failed: ' + res.status + ' ' + txt);
    }
  }

  async function changeLineQuantity(lineKey, qty) {
    const res = await fetch(cartRoute('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: Math.max(0, parseInt(qty, 10) || 0)
      })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error('Change line quantity failed: ' + res.status + ' ' + txt);
    }
  }

  async function convertLineToSubscription(lineKey, variantId, qty, sellingPlanId) {
    await changeLineQuantity(lineKey, 0);

    try {
      await addSubscription(variantId, qty, sellingPlanId);
    } catch (err) {
      await addSubscription(variantId, qty, null).catch(() => {});
      throw err;
    }
  }

  function getDrawerCartItemsComponent() {
    // Le drawer Horizon contient ce composant avec data-section-id
    return document.querySelector('cart-drawer-component cart-items-component[data-section-id]');
  }

  async function refreshDrawerSection() {
    const cartItems = getDrawerCartItemsComponent();
    if (!cartItems) return false;

    const sectionId = cartItems.getAttribute('data-section-id');
    if (!sectionId) return false;

    // Shopify Sections Rendering API: renvoie un JSON { [sectionId]: "<html>...</html>" }
    const url = `${cartRoute('/')}?sections=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });

    if (!res.ok) return false;

    const data = await res.json().catch(() => null);
    if (!data || !data[sectionId]) return false;

    const html = data[sectionId];

    // Parse HTML de la section renvoyée
    const tpl = document.createElement('template');
    tpl.innerHTML = html;

    // 1) Remplacer le contenu du cart-items-component (garde le drawer ouvert)
    const newCartItems = tpl.content.querySelector('cart-items-component[data-section-id]');
    if (newCartItems) {
      cartItems.innerHTML = newCartItems.innerHTML;
      // Re-upgrade des custom elements si besoin
      if (window.customElements && window.customElements.upgrade) {
        window.customElements.upgrade(cartItems);
      }
    }

    // 2) Mettre à jour les bulles panier (header + titre drawer)
    const currentBubbles = document.querySelectorAll('.cart-bubble');
    const newBubbles = tpl.content.querySelectorAll('.cart-bubble');

    if (currentBubbles.length && newBubbles.length) {
      // On remplace le contenu des bulles existantes par celles de la section re-rendue (même ordre)
      const n = Math.min(currentBubbles.length, newBubbles.length);
      for (let i = 0; i < n; i++) {
        currentBubbles[i].innerHTML = newBubbles[i].innerHTML;
      }
    }

    return true;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.custom-cart-subscribe-btn');
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const qty = btn.dataset.qty;
    // Cherche un select de fréquence dans le même bloc que le bouton
const wrapper = btn.closest('.custom-cart-subscribe');
const select = wrapper ? wrapper.querySelector('.custom-cart-subscribe__select') : null;

const sellingPlanId = select && select.value
  ? select.value
  : btn.dataset.sellingPlanId;

	const lineKey = btn.dataset.lineKey;

    if (!variantId || !sellingPlanId || !lineKey) return;

    const defaultLabel = btn.dataset.labelDefault;
const upgradingLabel = btn.dataset.labelUpgrading;
const errorLabel = btn.dataset.labelError || 'We could not switch this item to a subscription. Please try again.';

btn.disabled = true;
btn.setAttribute('aria-busy', 'true');

if (upgradingLabel) {
  btn.textContent = upgradingLabel;
}


    try {
      await convertLineToSubscription(lineKey, variantId, qty, sellingPlanId);

      const ok = await refreshDrawerSection();
      if (!ok) {
        // fallback simple si la section API n'est pas dispo / pas la bonne section
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
      alert(errorLabel);
    } finally {
  btn.disabled = false;
  btn.removeAttribute('aria-busy');

  if (defaultLabel) {
    btn.textContent = defaultLabel;
  }
}

  }, true);
})();
